export default __webpack_public_path__ + "static/media/TheDappList.66fb2c38.svg";